'use strict';

var React = require('react');

var SvgCustomersFilledMinor = function SvgCustomersFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.75a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5c-1.968 0-3.815.95-4.959 2.552l-.561.786a1.05 1.05 0 0 0 .855 1.662h9.33a1.05 1.05 0 0 0 .855-1.662l-.561-.786a6.094 6.094 0 0 0-4.959-2.552Z"
  }));
};
SvgCustomersFilledMinor.displayName = "CustomersFilledMinor";

exports.SvgCustomersFilledMinor = SvgCustomersFilledMinor;
